import { makeStyles } from '@material-ui/core';
import { colors } from 'styles/colors';
import fonts from 'styles/fonts';
import spacing from 'styles/spacing';

const useStyles = makeStyles({
  actionsButtons: {
    '& > *:first-child': {
      marginRight: spacing.xxxsmall,
    },
  },
  itemName: {
    width: '90%',
  },
  addItem: {
    color: colors.primary,
  },
  description: {
    fontSize: fonts.sizes.medium,
    fontWeight: fonts.weights.normal,
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },
  orderDescription: {
    fontSize: fonts.sizes.medium,
    fontWeight: fonts.weights.normal,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    marginRight: '16px',
  },
  descriptionContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  finishButtons: {
    '& > *:first-child': {
      marginRight: spacing.xsmall,
    },
  },
  addIcon: {
    marginTop: '-2px',
  },
});

export default useStyles;
